module.exports = __webpack_public_path__ + "static/img/20160919_005112-COLLAGE.d1fe64af.jpg";